import { QueryClient } from "@tanstack/react-query";
import {
  UseGetAdmissionsForMeKeyFn,
  UseGetOffersForMeKeyFn,
} from "src/generated/hooks/form-service/queries/common";

export async function refreshFormAdmissionsAfterMutation(
  queryClient: QueryClient,
  formId: string
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: UseGetAdmissionsForMeKeyFn({ path: { formId } }),
    }),
    queryClient.invalidateQueries({
      queryKey: UseGetOffersForMeKeyFn({ path: { formId } }, [formId]),
    }),
  ]);
}
